import { ListItem, ListItemText } from '@mui/material';
import type { FC } from 'react';
import type { LabourItemDefinitionSummary } from '../../../labour/types/labourItemTypes.ts';

interface LabourDefinitionOptionProps {
  definition: LabourItemDefinitionSummary;
  searchTerm: string;
}

/**
 * Molecule: Single option in autocomplete dropdown
 * Highlights matching text
 */
export const LabourDefinitionOption: FC<LabourDefinitionOptionProps> = ({
  definition,
  searchTerm,
}) => {
  // Highlight matching text
  const highlightText = (text: string) => {
    if (!searchTerm) return text;

    const parts = text.split(new RegExp(`(${searchTerm})`, 'gi'));
    return (
      <>
        {parts.map((part, index) =>
          part.toLowerCase() === searchTerm.toLowerCase() ? (
            <strong key={index}>{part}</strong>
          ) : (
            <span key={index}>{part}</span>
          )
        )}
      </>
    );
  };

  return (
    <ListItem>
      <ListItemText primary={highlightText(definition.name)} />
    </ListItem>
  );
};
